// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app_a4d61a194a269ee7b0aa{padding:24px}", "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA,0BACI,YAAA","sourcesContent":[".app {\n    padding: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": "app_a4d61a194a269ee7b0aa"
};
export default ___CSS_LOADER_EXPORT___;
